import { render, staticRenderFns } from "./UkrposhtaProduct.vue?vue&type=template&id=63ff3cb0&scoped=true"
import script from "./UkrposhtaProduct.vue?vue&type=script&lang=js"
export * from "./UkrposhtaProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff3cb0",
  null
  
)

export default component.exports